import { Typography } from "@mui/material"
import { CMLinkButton } from "../Button/Button"
import { FlexDivSpaceCenter } from "../Flex/Flex"
import { Add } from "@mui/icons-material"

interface HeaderProps {
  header: string,
  list?: boolean,
  value?: string,
  onClick?: any,
  link?: string
}

export const PageHeader = (props: HeaderProps) => {
  return (
    <FlexDivSpaceCenter style={{ marginBottom: 20, marginTop: 20 }}>
      <Typography variant="h6" sx={{ mb: 0 }}>
        {props.header}
      </Typography>
      {
        props.list ?
          <CMLinkButton link={props.link} icon={<Add/>} value={props.value} /> : null
      }
    </FlexDivSpaceCenter>
  )
}

PageHeader.defaultProps = {
  header: "",
  list: false,
  value: ""
}